import DataTable from './dataTable'
// import {storage} from '@/services/storage'

/******************************************************************************
 *  Deals
 *****************************************************************************/

/**
 * @type {Deal}
 */
export default class Deal extends DataTable {

    constructor () {
        /** Verifica se as requisições do datatable serão feitas para a API V1 ou API V2 */
        // const funnelMongo = JSON.parse(storage.get('funnel_mongo'))
        // const httpId = (funnelMongo && funnelMongo.active && funnelMongo.active == 1) ? 'http2' : 'http'
        super('funnel/deal', '/deals', 'http2')

        this.columns = [
            this.prototypes.column('customer_name', 'customers.name', true, true),
            this.prototypes.column('user_name', 'users.user_name', true, true),
            this.prototypes.column('stage', 'stg.id', true, true),
            this.prototypes.column('origin_id', 'deal.origin_id', false, false),
            this.prototypes.column('product_id', 'p.id', true, true),
            this.prototypes.column('product_name', 'p.name', true, true),
            this.prototypes.column('cost', 'deal.cost', false, true),
            this.prototypes.column('customer_phone', 'customers.phone', true, false),
            this.prototypes.column('customer_mobile', 'customers.mobile', true, false),
            this.prototypes.column('customer_email', 'customers.email', true, false),
            this.prototypes.column('updated_at', 'deal.updated_at', false, true),
            this.prototypes.column('saled_at', 'deal.saled_at', false, true),
            this.prototypes.column('11', '', false, false),
            this.prototypes.column('created_at', 'deal.created_at', false, true),
            this.prototypes.column('reserves', 'reserve.reserve', true, false),
            this.prototypes.column('funnel_stage_id', 'deal.funnel_stage_id', false, false),
            this.prototypes.column('stage', 'deal.funnel_stage', false, false),
            this.prototypes.column('id', 'deal.id', true, false),
            this.prototypes.column('team_id', 't.id', false, false),
            this.prototypes.column('manager_id', 'mfo.id', false, false),
            this.prototypes.column('broker_id', 'bfo.id', false, false),
            this.prototypes.column('customer_email', 'customers.email', true, false),
            this.prototypes.column('customer_cpf', 'customers.cpf', true, false),
            this.prototypes.column('funnel_stage_status_id', 'deal.funnel_stage_status_id', false, false, { value: "", regex: true }),
            this.prototypes.column('customer_mobile', 'customers.mobile', true, false),
            this.prototypes.column('customer_phone', 'customers.phone', true, false),
            this.prototypes.column('tags', 'tags.tag', false, true),
            this.prototypes.column('owner', 'filter_owner', false, true),
            this.prototypes.column('idle_color', 'idle.updated_at', false, true),
            this.prototypes.column('idle_color_v2', 'idle.updated_at', false, true),
            this.prototypes.column('tasks', 'task.updated_at', false, true),
            this.prototypes.column('customer_id', 'deal.customer_id', true, false),
            this.prototypes.column('customer_origin', '', false, false),
            this.prototypes.column('channel_id', '', true, false),
            this.prototypes.column('user_id', '', true, false)
        ]
    }

    /**
     * Sobreescrita do método básico REST que busca as instâncias de modo
     * a utilizar o novo endpoint com classes service e repository
     *
     * @param {String} url
     * @param {Object} params
     */
    getAll(url, params, config = {}) {
        return this.http.get(
            this.constructor.normalize('/funnel/deal/new', url), {
                params,
                ...config
            }
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Método para buscar todos os négocios, e que será utilizado pelo card na
     * dashboard
     *
     * @param {String} url
     * @param {*} params
     */
    getData(url, params) {
        return this.getAll(url, params)
    }

    /**
     * Busca todos os filtros necessários para o card da dashboard
     */
    getCustomerTags() {
        return this.http.get('/tags/Customer_Main').then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Busca todos os filtros necessários para o card da dashboard
     */
    readFilters() {
        return this.getCustomerTags().then(response => {
            const data = response.data
                .map((item) => {
                    return { id: item.tag, text: item.tag }
                })
            response.data = data

            return response
        });
    }

    procedure(id, formData) {
        return super.update(id + '/procedure', '', formData)
    }

	activeFunnelDealById(id) {
		return this.http.get('funnel/deal/' + id + '/active').then(response => {
			if (response.data && response.data.status === 'error') return Promise.reject(response)

			return response
		})
	}

	linkFileToDeal(dealId, fileId) {
		return this.http.post('funnel/deal/' + dealId + '/files/' + fileId).then(response => {
			if (response.data && response.data.status === 'error') return Promise.reject(response)

			return response
		})
	}

	removeFileToDeal(dealId, fileId) {
		return this.http.delete('funnel/deal/' + dealId + '/files/' + fileId).then(response => {
			if (response.data && response.data.status === 'error') return Promise.reject(response)

			return response
		})
	}

	getModels(dealId) {
		return this.http2.get('contracts/deal/' + dealId + '/list').then(response => {
			if (response.data && response.data.status === 'error') return Promise.reject(response)

			return response
		})
	}

	getContractFromModel(fileId, dealId) {
		return this.http.get('contracts/' + fileId + '/deal/' + dealId).then(response => {
			if (response.data && response.data.status === 'error') return Promise.reject(response)

			return response
		})
	}

	generateContractFromModel(fileId, dealId) {
		return this.http.post('contracts/' + fileId + '/deal/' + dealId + '/save').then(response => {
			if (response.data && response.data.status === 'error') return Promise.reject(response)

			return response
		})
	}

    /**
     * Recebe o ID de um negócio e busca o QR code referente à este negócio
     *
     * @param {String|Number} id ID do negócio
     * @returns 
     */
    getQRCode(id) {
        return this.http.get(`configs/qrcode/Deal_Main__${id}/300`).then(response => {
			if (response.data && response.data.status === 'error') return Promise.reject(response)

			return response
		})        
    }
}